import request from '@/utils/request'

// 分页查询教育课程
export function pageEduCourse(data) {
  return request({
    url: '/biz/admin/edu/course/page',
    method: 'post',
    data: data
  })
}

// 教育课程详情(含单节课)
export function getEduCourse(data) {
  return request({
    url: '/biz/admin/edu/course/detail',
    method: 'post',
    data: data
  })
}

// 新增教育课程
export function addEduCourse(data) {
  return request({
    url: '/biz/admin/edu/course/add',
    method: 'post',
    data: data
  })
}

// 修改教育课程
export function updateEduCourse(data) {
  return request({
    url: '/biz/admin/edu/course/edit',
    method: 'post',
    data: data
  })
}

// 上下架教育课程
export function changeEduCourseStatus(data) {
  return request({
    url: '/biz/admin/edu/course/changeStatus',
    method: 'post',
    data: data
  })
}

// 删除教育课程
export function delEduCourse(data) {
  return request({
    url: '/biz/admin/edu/course/delete',
    method: 'post',
    data: data
  })
}
